import { Box, Typography } from "@mui/material";

import APTable from "../../../../components/APTable";
import CRMButton from "../../../../components/buttons/CRMButton";
import { formatDate } from "../../../../helpers/dates";
import { getInvoiceCRMUrl } from "../../../../helpers/dossiers";
import {
  getDateForInvoiceComparison,
  InvoiceComparisonSummary,
} from "../../../../types/Document";

type TableDataDefinition = {
  date: string;
  comparisonStatus: "matching" | "missing";
  invoiceId: string;
  ceInvoice: string;
  crmInvoice: string;
};

const APInvoiceComparisonTable = ({
  invoiceComparisons,
  crmClientURL,
}: {
  invoiceComparisons: InvoiceComparisonSummary[];
  crmClientURL: string | null;
}) => {
  const renderMissingText = (missingCRM: boolean, missingCatchE: boolean) => {
    if (missingCRM) {
      return " - CRM";
    } else if (missingCatchE) {
      return " - CE";
    }
    return "";
  };

  const comparisonRowRenderer = (
    row: Partial<Record<keyof TableDataDefinition, string>>
  ) => {
    return {
      date: <Typography variant="bodyMedium">{row.date}</Typography>,
      comparisonStatus: (
        <Typography
          variant="bodyMedium"
          color={row.comparisonStatus !== "matching" ? "error.main" : undefined}
        >
          {row.comparisonStatus}
          {row.comparisonStatus === "missing"
            ? renderMissingText(!row.crmInvoice, !row.ceInvoice)
            : ""}
        </Typography>
      ),
      crmInvoice: (
        <Box sx={{ display: "flex", alignItems: "center", columnGap: 0.5 }}>
          {crmClientURL && row.crmInvoice && (
            <CRMButton
              url={getInvoiceCRMUrl(crmClientURL, row.crmInvoice)}
              sx={{ p: { sm: 1, xs: 0.5 } }}
              size="small"
            />
          )}
        </Box>
      ),
    };
  };

  const buildComparisonRows = (
    comparisons: InvoiceComparisonSummary[]
  ): Partial<Record<string, string>>[] => {
    return comparisons.map((comparison) => {
      return {
        invoiceId: comparison.invoiceId,
        date: formatDate(getDateForInvoiceComparison(comparison)),
        comparisonStatus: comparison.status as "matching" | "missing",
        ceInvoice: comparison.ceInvoice?.id ?? "",
        crmInvoice: comparison.crmInvoice?.id ?? "",
      };
    });
  };

  return (
    <APTable
      columns={["date", "invoiceId", "comparisonStatus", "crmInvoice"]}
      headerRows={{
        date: { title: "Date" },
        invoiceId: { title: "Invoice ID" },
        comparisonStatus: { title: "Comparison Status" },
        crmInvoice: { title: "CRM Invoice" },
      }}
      rows={buildComparisonRows(invoiceComparisons)}
      rowRenderer={comparisonRowRenderer}
    />
  );
};

export default APInvoiceComparisonTable;
